import { SET_TITLE, HeaderActions, HeaderState, initialState } from './types'

const reducers = (state: any = initialState, action: HeaderActions): HeaderState => {
  switch (action.type) {
    case SET_TITLE:
      return {
        ...state,
        title: action.payload,
      }
    default:
      return state
  }
}

export default reducers
